import React from 'react';
import styled from 'styled-components';

const Container = styled.div`
  width: 550px;
  box-shadow: 0 0 40px #0000000f;
  border-radius: 14px;
  padding: 33px;
  position: fixed;
  left: calc(50% - 275px);
  top: 50px;
  z-index: 600;
  display: flex;
  flex-direction: column;
  background: white;
  max-height: calc(100vh - 100px);
  overflow-y: scroll;
`;

const Content = styled.div``;

type Props = {
  children?: React.ReactNode;
};

const Card = ({ children }: Props) => {
  return (
    <Container>
      <Content>{children}</Content>
    </Container>
  );
};

export default Card;
